module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isSVG) ? _c('icon', {
    staticClass: "c-icon u-inline-block u-valign-middle",
    attrs: {
      "name": _vm.name,
      "width": _vm.width,
      "height": _vm.height,
      "scale": _vm.scale
    }
  }) : _c('img', {
    staticClass: "c-icon u-inline-block u-valign-middle",
    attrs: {
      "src": '/static/images/icons/' + _vm.name,
      "width": _vm.width,
      "height": _vm.height,
      "alt": "",
      "title": ""
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5882c96c"}!./src/scripts/components/app-icon/template.html
// module id = 468
// module chunks = 0